import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
/**
 *
 */
export class JaTextElementBlock extends AbstractBlock {
  JA_FONT = 'JA_FONT';

  JA_BG_COLOR = 'JA_BG_COLOR';

  JA_TEXT = 'JA_TEXT';

  constructor(title: string) {
    super('ja_text', title);
    this.setNameForCode('a-plane');
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);

    ShapeSettings.setTitleField(block, this.title);

    //--
    const text = new Blockly.FieldTextInput(t.to('にほん語の文字', 'japanese_words'));
    const font = new Blockly.FieldTextInput('100');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(this.title)
      .appendField(text, this.JA_TEXT)
      .appendField(` ${t.to('文字サイズ', 'word_size')}:`)
      .appendField(font, this.JA_FONT);

    ShapeSettings.addAttributeInput(block);
  }

  generateStaticHTMLCode(block: BlockType): string {
    const text = CodeSetting.getFieldValue(block, this.JA_TEXT);
    const font = CodeSetting.getFieldValue(block, this.JA_FONT);

    const id = this.hashedId(block);
    const color = 'white';
    const str = `
		<a-plane id="${id}" material="shader: html; target: #${id}1">
			<div id="${id}1" style="position: fixed; z-index:-1000; background-color:${color}; font-size:${font}px;"  >
			${text}
			</div>
		</a-plane>
		`;
    return str;
  }

  codeGenerateCore(block: BlockType): string {
    const id = this.hashedId(block);
    let attribute = CodeSetting.getSubAttributeCode(block);
    attribute += CodeSetting.getAttributeCode('material', `#${id}`);
    const str = CodeSetting.getElementCode('a-plane', attribute, block.id, '');
    return str;
  }
}
